import { render, staticRenderFns } from "./GameCountTrend.vue?vue&type=template&id=ddab474e&scoped=true"
import script from "./GameCountTrend.vue?vue&type=script&lang=js"
export * from "./GameCountTrend.vue?vue&type=script&lang=js"
import style0 from "./GameCountTrend.vue?vue&type=style&index=0&id=ddab474e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddab474e",
  null
  
)

export default component.exports